import { Controller } from "react-hook-form";
import { Password } from "primereact/password";

import { PasswordInputProps, ValidateRulesPassword } from "../../../interfaces";
import { noEmojiRegex, passwordRegex } from "utils";
import {
  erroreCampoObbligatorio,
  erroreCaratteriNonValidi,
  erroreFormato,
  errorPasswordNotMatching,
  labelDebole,
  labelForte,
  labelIniziaADigitare,
  labelMedio,
} from "../../../_constants";
import { FooterSuggestionsPassword } from "components/PasswordSuggestions/FooterSuggestionsPassword";
import { HeaderSuggestionsPassword } from "components/PasswordSuggestions/HeaderSuggestionsPassword";
import { useAppDispatch, useAppSelector } from "store/store";
import { setLoginFormValid } from "store/slicer/FormLoginValidationSlice";

export const PasswordInput = ({
  control,
  name,
  placeholder,
  password,
  feedback = false,
  triggerEvent,
  isLogin = false,
  onFocusCallback,
}: PasswordInputProps) => {
  const validate: ValidateRulesPassword = {};
  if (name === "password" || name === "oldPassword") {
    validate.passwordFormat = (value) =>
      passwordRegex.test(value) || erroreFormato;
    validate.noEmoji = (value) =>
      !noEmojiRegex.test(value) || erroreCaratteriNonValidi;
  } else {
    validate.passwordMatch = (value) =>
      value === password || errorPasswordNotMatching;
  }
  const dispatch = useAppDispatch();
  const isLoginFormValid = useAppSelector(
    (state) => state.formLoginValidationSlice.loginFormIsValid
  );

  const resetRegisterValidationStatus = () => {
    if (onFocusCallback) {
      onFocusCallback();
    }
    dispatch(setLoginFormValid(true));
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={
        isLogin
          ? {
              required: erroreCampoObbligatorio,
              validate: {
                emailCheck: () => {
                  return isLoginFormValid;
                },
              },
            }
          : {
              required: erroreCampoObbligatorio,
              validate: validate,
            }
      }
      render={({ field, fieldState: { error, isTouched } }) => (
        <div className="flex-container column password-full-width">
          <Password
            promptLabel={labelIniziaADigitare}
            weakLabel={labelDebole}
            mediumLabel={labelMedio}
            strongLabel={labelForte}
            autoComplete={field.name}
            pt={{
              input: { className: "width-100" },
            }}
            id={field.name}
            {...field}
            className={`w-full ${
              isLogin
                ? !isLoginFormValid
                  ? "p-invalid "
                  : ""
                : error && isTouched
                ? "p-invalid margin-bottom-4"
                : "p-info"
            } `}
            placeholder={placeholder}
            toggleMask
            header={HeaderSuggestionsPassword}
            footer={FooterSuggestionsPassword}
            feedback={feedback}
            onChange={(e) => {
              field.onChange(e.target.value);
              if (triggerEvent) triggerEvent();
            }}
            onBlur={() => {
              field.onBlur();
              if (triggerEvent) triggerEvent();
            }}
            onFocus={resetRegisterValidationStatus}
          />
          {!isLogin && isTouched && error && (
            <small className="p-error">{error.message}</small>
          )}
        </div>
      )}
    />
  );
};
